module.exports = __webpack_public_path__ + "media/alaska/turd_tea-5f2242e4.jpg";